import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private db: AngularFireDatabase) { }

  getAll(){
    return this.db.list('/natural_person', ref => ref.orderByChild('created')).valueChanges();
  }

  getPage(start, offset){
    return this.db.list('/natural_person',ref => ref.startAt(start).limitToFirst(offset+1)).valueChanges();
  }
}
